const games = [
  {
    id: 1,
    name: "Projet Origami",
    isBeta: true,
    isAI: true,
    isBetaVisible: true,
    description:
      "Plongez dans un monde numérique plein de pièges et d'énigmes technologiques. Une expérience coopérative entre stratégie et hacking éthique.",
    storyTeaser:
      "Une heure et demie avant une conférence cruciale, votre équipe produit reçoit un message d'urgence : Origami, votre assistant IA phare, a été copié et tout indique qu'une fuite interne a eu lieu. Sous pression, chacun se retrouve isolé dans une pièce différente. Votre mission : recouper des indices dispersés, analyser des traces techniques ambiguës et remonter la chaîne des événements avant le lancement. Entre fichiers verrouillés et signaux inhabituels, l'enquête devient un jeu de déduction collectif où chaque rôle compte. Disons simplement que la \"source\" de la fuite n'est peut-être pas celle que vous imaginez.",
    difficulty: "Intermédiaire",
    duration: "90 min",
    players: "4–6 joueurs",
    image:
      "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1000&q=80",
    dimensions: [
      { label: "Inspection & Observation", value: 20, color: "#1c1fe0" },
      { label: "Coopération & Communication", value: 40, color: "#f116f9" },
      { label: "Énigmes & Logique", value: 40, color: "#0fcaeb" },
    ],
    pillars: [
      {
        icon: "",
        title: "Enquête collective",
        text: "Chaque joueur explore une pièce distincte et détient des informations uniques. Sans communication, l'enquête est impossible.",
      },
      {
        icon: "",
        title: "Énigmes progressives",
        text: "Des puzzles logiques qui s'enchaînent sur 3 actes distincts, avec une montée en tension jusqu'à la révélation finale.",
      },
      {
        icon: "",
        title: "Pression & cohésion",
        text: "90 minutes, un compte à rebours, et une équipe qui doit rester soudée sous pression. Le meilleur team building, version numérique.",
      },
    ],
    tags: ["Espionnage corporate", "IA & tech", "Enquête"],
  },
  {
    id: 2,
    name: "Séminaire en détresse",
    isBeta: false,
    isPreview: true,
    isAI: false,
    isBetaVisible: false,
    description:
      "Votre PDG a réservé un séminaire d'entreprise à Mulhouse, mais le prestataire a tout planté en achetant un perroquet et 47 kg de chips paprika. Vous avez 60 minutes pour sauver le séminaire avant que les bus partent.",
    storyTeaser:
      "Une comédie absurde où chaque décision compte. À 17h, vous devez avoir choisi qui part, où ils dorment, ce qu'ils mangent et quelles activités ils feront. Le tout sans dépasser un budget devenu microscopique. Avec une équipe d'employés tous plus loufoques les uns que les autres.",
    difficulty: "Facile",
    duration: "60 min",
    players: "3–5 joueurs",
    releaseTarget: "Été 2026",     // 👈 cible de sortie pour la card preview
    image:
      "/assets/mulhouseCatalogue.png",
    tags: ["Comédie absurde", "Décisions", "Coopération"],
  },
  {
    id: 3,
    name: "L'Héritage Perdu",
    isBeta: false,
    isBetaVisible: false,
    isAI: true,
    description:
      "Un voyage à travers les siècles pour retrouver un héritage disparu. Collaboration, observation et intuition seront vos meilleures armes.",
    difficulty: "Facile",
    duration: "45 min",
    players: "4–6 joueurs",
    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1000&q=80",
  },
  {
    id: 4,
    name: "Cyber Intrigue",
    isBeta: false,
    isBetaVisible: false,
    isAI: true,
    description:
      "Plongez dans un monde numérique plein de pièges et d'énigmes technologiques. Une expérience coopérative entre stratégie et hacking éthique.",
    difficulty: "Avancé",
    duration: "90 min",
    players: "4–6 joueurs",
    image:
      "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1000&q=80",
  },
  {
    id: 5,
    name: "Le Secret du Bureau",
    isBeta: false,
    isBetaVisible: false,
    isAI: true,
    description:
      "Résolvez une série d'énigmes en équipe pour découvrir ce que cache le PDG de votre entreprise fictive. Un scénario immersif mêlant logique et coopération.",
    difficulty: "Intermédiaire",
    duration: "60 min",
    players: "4–6 joueurs",
    image:
      "https://images.unsplash.com/photo-1522205408450-add114ad53fe?auto=format&fit=crop&w=1000&q=80",
  },
];

export default games;